import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { InstallableModuleType } from '../../../../../types/layout';
import { getInstallableModulesInfo } from '../../../../selectors/layout';
import { Props } from './WidgetTypeCard';

type StateProps = Pick<Props, 'limit' | 'restrict' | 'installedCount'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  { section, zone, moduleName }
) => {
  const modulesInfo = getInstallableModulesInfo(state, section, zone) || [];
  const moduleInfo = modulesInfo.find(m => m.moduleName === moduleName) || {};
  const {
    limit = 0,
    restrict = undefined,
    installedCount = 0,
  } = moduleInfo as InstallableModuleType;
  return {
    limit,
    restrict,
    installedCount,
  };
};

export default connect(mapStateToProps);
